<template>
  <div :class="{ 'menu-tree-box': true }">
    <template v-for="(item, index) in menu">
      <el-submenu
        v-if="item.children && item.children.length > 0 && !item.hidden"
        :key="index + 'el-submenu'"
        :index="item.router"
      >
        <template slot="title">
          <i :class="`menuIcon ${item.icon}`" v-if="showIcon" />

          <span slot="title">{{ item.name }}</span>
        </template>
        <menuTree :menu="item.children" />
      </el-submenu>
      <el-menu-item v-else :key="index + item.router" :index="item.router">
        <i :class="`menuIcon ${item.icon}`" v-if="showIcon" />
        <span slot="title">{{ item.name }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
import menuTree from "./index";
export default {
  name: "menuTree",
  props: {
    menu: {
      type: Array,
      default: [],
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    menuTree,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scope>
.menuIcon {
  font-size: 20px;
  margin-right: 5px;
}
</style>
<style lang="scss">
.el-menu--collapse {
  .menu-tree-box {
    .el-submenu {
      &.is-active {
        .menuIcon {
          color: #409eff;
        }
      }
      .el-submenu__title {
        span {
          display: none;
        }
        .el-submenu__icon-arrow {
          display: none;
        }
      }
    }
  }
}
</style>
